"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactLoading = _interopRequireDefault(require("react-loading"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _Loading = _interopRequireDefault(require("./Loading.styles"));

var _core = require("@emotion/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Loading = function Loading(_ref) {
  var show = _ref.show,
      className = _ref.className,
      isSmall = _ref.isSmall,
      center = _ref.center,
      loadingColor = _ref.loadingColor,
      style = _ref.style;
  var theme = (0, _emotionTheming.useTheme)();

  var getColor = function getColor() {
    if (loadingColor) return loadingColor;

    if (Object.prototype.hasOwnProperty.call(theme, 'getColor')) {
      return theme.getColor('primary');
    }

    return '#7d1dd1';
  };

  return show && (0, _core.jsx)(_Loading["default"], {
    style: style,
    className: className,
    center: center
  }, (0, _core.jsx)(_reactLoading["default"], {
    type: "spin",
    color: getColor(),
    height: isSmall ? 50 : 100,
    width: isSmall ? 50 : 100
  }));
};

Loading.defaultProps = {
  center: false,
  className: '',
  isSmall: false,
  loadingColor: undefined,
  show: false,
  style: {}
};
Loading.propTypes = {
  center: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  isSmall: _propTypes["default"].bool,
  loadingColor: _propTypes["default"].string,
  show: _propTypes["default"].bool,
  style: _propTypes["default"].object
};
var _default = Loading;
exports["default"] = _default;

//# sourceMappingURL=Loading.js.map